import type { CalculationType } from "../../calculations/calculationTypes";
import { useAsyncDialog } from "../../sharedComponents/useAsyncDialog";
import CancelButton from "../../components/cancelButton/CancelButton";
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import React from "react";

export type GenerateCalculationPdfDialogResult = "no-prices" | "include-prices";
export function useGenerateCalculationPdfDialog(args: { type: CalculationType }) {
  return useAsyncDialog<GenerateCalculationPdfDialogResult>(({ onAccept, onCancel }) => (
    <Dialog open onClose={onCancel}>
      <DialogTitle>Generuj PDF</DialogTitle>
      <DialogActions>
        <CancelButton onClick={onCancel} />
        <Button variant="outlined" onClick={() => onAccept("no-prices")}>
          Bez cen opcji
        </Button>
        <Button
          variant="contained"
          disableElevation
          onClick={() => onAccept("include-prices")}
          disabled={args.type === "PACKAGE"}
        >
          Z cenami opcji
        </Button>
      </DialogActions>
    </Dialog>
  ));
}
